<template>
  <div class="ticket-table-card">
    <div class="table-title">{{ticketTableTitle}}</div>
    <el-table :data="tableData"
              style="width: 100%"
              max-height="300">
      <!-- 序号 -->
      <el-table-column prop="serialNo"
                       width="50"
                       type="index"
                       :label="this.$t('alarmHistory.index')">
      </el-table-column>
      <!-- A端机柜编码 -->
      <el-table-column prop="aCabinetNo"
                       :label="this.$t('serviceSupport.xCabinetNumCode',['A'])">
      </el-table-column>
      <!-- A端房间号 -->
      <el-table-column prop="aRoomNo"
                       :label="this.$t('serviceSupport.xRoomNum',['A'])">
      </el-table-column>
      <!-- B端机柜编码 -->
      <el-table-column prop="bCabinetNo"
                       :label="this.$t('serviceSupport.xCabinetNumCode',['B'])">
      </el-table-column>
      <!-- B端房间号 -->
      <el-table-column prop="bRoomNo"
                       :label="this.$t('serviceSupport.xRoomNum',['B'])">
      </el-table-column>
      <!-- 备注 -->
      <el-table-column prop="remark"
                       show-overflow-tooltip
                       :label="this.$t('text.note')">
        <template slot-scope="scope">
          <span>{{scope.row.remark | maybeEmpty}}</span>
        </template>
      </el-table-column>
      <!-- 现场反馈 -->
      <el-table-column :label="this.$t('serviceSupport.siteFeedback')">
        <template slot-scope="scope">
          <span>{{scope.row.result | maybeEmpty}}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import cloneDeep from 'lodash';

export default {
  props: {
    // info
    tableData: {
      type: Array,
      default () { return null; },
    },
    ticketTableTitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    ticketInfoTableCopy () {
      return cloneDeep(this.ticketInfo);
    }
  }
};
</script>
<style lang="scss" scoped>
.table-title {
  height: 40px;
  line-height: 40px;
  background-color: #f3f7fb;
  border: 1px solid #d9e1e9;
  font-size: 13px;
  border-bottom: none;
  padding-left: 8px;
}
.ticket-table-card {
  margin: 10px 0 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/workSheet/common/CabinetABTable.vue